import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DoneIcon from '@mui/icons-material/Done';
import {getRandomCoins} from '../../utils/helper';
import {QUESTION_TYPES} from '../../constants/appConstants';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import IconButton from '@mui/material/IconButton';
import {VideoAd} from './VideoAd';
import DeveloperInfo from '../common/DeveloperInfo';
import {getCoinsIcon} from '../common/simpleComponents';
import {ACROSS} from '../../constants/crosswordConstant';

export default function HintDialog({settings, questionType}) {
  const [open, setOpen] = React.useState(false);
  const [showHint, setShowHint] = React.useState(false);
  const [hintNotAvailable, setHintNotAvailable] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickActionSuccess = () => {
    setShowHint(true)
    // setOpen(false);
  }

  const getHint = () => {
    let hint = <>It's a domestic animal</>

    const crossWordhint = <>
      <DeveloperInfo>Reveal answer for any one clue. If it's already solved/revealed by user,
        then reveal answer for some other clue.</DeveloperInfo>
      {Object.entries(ACROSS).map(([_, acrossVal]) => {
        return <p>{acrossVal.clue} - Answer: <b>{acrossVal.answer}</b></p>
      })}
    </>

    const wordleHint = <>
      <DeveloperInfo><ol>
        <li>Reveal one correct letter by placing them in correct position in letter grid.</li>
        <li>And highlight it in green color. Add animation effect after closing this window.</li>
        <li>Don't reveal the same letter which are already in correct place..</li>
        <li>Disable hint option when user exceeds maximum number of attempts.</li>
        </ol>
        </DeveloperInfo>
      Letter "D" is placed in correct position
    </>

    switch (questionType) {
      case QUESTION_TYPES.CROSS_WORD_PUZZLE:
        hint = crossWordhint
        break
      case QUESTION_TYPES.WORDLE:
        hint = wordleHint
        break
      default:
        break
    }
    return hint

  }


  return (
    <React.Fragment>
      <IconButton aria-label="hint" onClick={handleClickOpen}>
        <TipsAndUpdatesIcon color={settings.hint ? 'secondary' : undefined}/>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Hint
        </DialogTitle>
        <DialogContent>
          {/* <DeveloperInfo>
            Hints are optional . <Button onClick={() => {
            setHintNotAvailable(!hintNotAvailable);
          }}> Show/Hide hint not available for this question</Button>
          </DeveloperInfo> */}
          <DialogContentText id="alert-dialog-description">
            {!hintNotAvailable ? (<>
                {showHint ? <>{getHint()}</> :
                  <>
                    View hint for {questionType} using coins or by watching Ad. You've {' '}
                    <b>{getRandomCoins()} coins </b>
                    left in your wallet.
                  </>
                }
              </>) :
              <>Hint is not available</>}

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!hintNotAvailable ? (<>
              <Button onClick={handleClose}>Cancel</Button>
              {!showHint ? <>
                <VideoAd handleVideoAdComplete={handleClickActionSuccess}/>
                <Button onClick={handleClickActionSuccess} variant={'contained'}
                        endIcon={getCoinsIcon()}>
                  2 coins</Button>
              </> : <Button onClick={handleClose} variant={'contained'} endIcon={<DoneIcon/>}>
                Ok! Close
              </Button>}
            </>) :
            <Button onClick={handleClose} variant={'contained'}>Close</Button>}

        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
